import {
  FETCH_DASHBOARD_BINS,
  FETCH_DASHBOARD_BINS_SUCCESS,
  FETCH_DASHBOARD_BINS_FAIL,
  FETCH_TOTAL_PENDING_ALERTS,
  FETCH_TOTAL_PENDING_ALERTS_SUCCESS,
  FETCH_TOTAL_PENDING_ALERTS_FAIL,
  FETCH_CASE_AGING_STATS,
  FETCH_CASE_AGING_STATS_SUCCESS,
  FETCH_CASE_AGING_STATS_FAIL,
  UPDATE_DASHBOARD_FILTERS
} from '../../actions/cm/dashboard';
import { DEFAULT_DATE_RANGE_DAYS } from '../../../pages/constants/cmConstants';
import { fromDaysToRangeBack } from '../../../pages/cm/utils/common';

const { from, to } = fromDaysToRangeBack(DEFAULT_DATE_RANGE_DAYS);

export const initialState = {
  dashboardBins: [],
  totalPendingAlerts: 0,
  totalCaseAgingStats: 0,
  autoCases: 0,
  manualCases: 0,
  otherCases: 0,
  caseAgingStats: [],
  loadDashboardBins: false,
  loadTotalAlerts: false,
  loadCaseAgingStats: false,
  hasError: false,
  filters: {
    from,
    to
  },
  hasLoaded: false,
  hasLoadedAlerts: false,
  httpConfig: null
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_DASHBOARD_BINS:
      return {
        ...state,
        loadDashboardBins: true,
        hasError: false
      };
    case FETCH_DASHBOARD_BINS_SUCCESS:
      return {
        ...state,
        dashboardBins: payload?.dashboardBins || [],
        httpConfig: payload?.httpConfig || null,
        loadDashboardBins: false
      };
    case FETCH_DASHBOARD_BINS_FAIL:
      return {
        ...state,
        loadDashboardBins: false,
        hasError: true
      };
    case FETCH_TOTAL_PENDING_ALERTS:
      return {
        ...state,
        loadTotalAlerts: true,
        hasError: false,
        hasLoadedAlerts: false
      };
    case FETCH_TOTAL_PENDING_ALERTS_SUCCESS:
      return {
        ...state,
        totalPendingAlerts: payload || 0,
        loadTotalAlerts: false,
        hasLoadedAlerts: true
      };
    case FETCH_TOTAL_PENDING_ALERTS_FAIL:
      return {
        ...state,
        loadTotalAlerts: false,
        hasError: true
      };
    case FETCH_CASE_AGING_STATS:
      return {
        ...state,
        loadCaseAgingStats: true,
        hasError: false,
        hasLoaded: false
      };
    case FETCH_CASE_AGING_STATS_SUCCESS:
      return {
        ...state,
        totalCaseAgingStats: payload.total || 0,
        caseAgingStats: payload.ages || [],
        autoCases: payload.automationCases || 0,
        manualCases: payload.manualCases || 0,
        otherCases: payload.otherCases || 0,
        loadCaseAgingStats: false,
        hasLoaded: true
      };
    case FETCH_CASE_AGING_STATS_FAIL:
      return {
        ...state,
        loadCaseAgingStats: false,
        hasError: true
      };
    case UPDATE_DASHBOARD_FILTERS:
      return {
        ...state,
        filters: payload,
        hasLoaded: false
      };
    default:
      return state;
  }
}
